export default __webpack_public_path__ + "static/media/Raion_mobile.8d1d5979.jpg";